import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../environments/environment";
import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { RekbotNote } from "../rekbots/rekbot-layout/rekbot-layout-models/rekbot-note.model";

@Injectable({ providedIn: 'root' })
export class RekbotNotesService {
    
    constructor(
        private http:HttpClient,
        private authService: AuthService,
        private router: Router,
    ){}

    getNotes(rekbotId:string | number){
        const endpoint = environment.apiUrl + '/api/rekbots/' + rekbotId + '/notes';

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }

        const bearerToken = 'Bearer ' + this.authService.getToken();
        return this.http.get<RekbotNote[]>(endpoint, {headers: new HttpHeaders().set('Authorization', bearerToken)})
    }

    getNote(rekbotId:string | number, noteId:string | number) {
        const endpoint = environment.apiUrl + '/api/rekbots/' + rekbotId + '/notes/' + noteId;

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }

        const bearerToken = 'Bearer ' + this.authService.getToken();
        return this.http.get<RekbotNote>(endpoint, {headers: new HttpHeaders().set('Authorization', bearerToken)})
    }

    addNote(rekbotId:string | number, body:RekbotNote | FormData) {
        const endpoint = environment.apiUrl + '/api/rekbots/' + rekbotId + '/notes';

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }

        const bearerToken = 'Bearer ' + this.authService.getToken();
        return this.http.post(endpoint,body,{headers: new HttpHeaders().set('Authorization', bearerToken), responseType: 'text'})
    }

    updateNote(rekbotId:string | number, noteId:string | number, body:RekbotNote | FormData) {
        const endpoint = environment.apiUrl + '/api/rekbots/' + rekbotId + '/notes/' + noteId;

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }

        const bearerToken = 'Bearer ' + this.authService.getToken();
        return this.http.put(endpoint,body,{headers: new HttpHeaders().set('Authorization', bearerToken)})
    }

    deleteNote(rekbotId: string | number, noteId: string | number) {
        const endpoint = environment.apiUrl + '/api/rekbots/' + rekbotId + '/notes/' + noteId;

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        

        const bearerToken = 'Bearer ' + this.authService.getToken();
        return this.http.delete(endpoint,{headers: new HttpHeaders().set('Authorization', bearerToken)})
    }

    requestDeleteNote(rekbotId: string | number, noteId: string | number, deleteReason: string) {
        const endpoint = environment.apiUrl + '/api/rekbots/' + rekbotId + '/notes/' + noteId + '/request-delete';

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }

        const bearerToken = 'Bearer ' + this.authService.getToken();
        return this.http.post(endpoint,{delete_reason: deleteReason}, {headers: new HttpHeaders().set('Authorization', bearerToken)})
    }

    confirmDeleteNote(rekbotId: string | number, noteId: string | number) {
        const endpoint = environment.apiUrl + '/api/rekbots/' + rekbotId + '/notes/' + noteId + '/approve-delete';

        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }

        const bearerToken = 'Bearer ' + this.authService.getToken();
        return this.http.post(endpoint, {}, {headers: new HttpHeaders().set('Authorization', bearerToken)})
    }

    fetchRequestDeleteNote() {
        const endpoint = environment.apiUrl + '/api/rekbots/notes/pending-delete-requests';
        if (this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }

        const bearerToken = 'Bearer ' + this.authService.getToken();
        return this.http.get<{count:number, requests:RekbotNote[]}>(endpoint, {headers: new HttpHeaders().set('Authorization', bearerToken)})
    }

    cancelRequestDeleteNote(rekbotId: string | number, note: RekbotNote) {
        note.delete_reason = "";
        return this.updateNote(rekbotId, note.id!, note);
    }
}

// fetchRekbotSettings(id: number) {
//     const endpoint = environment.apiUrl + '/api/rekbots/' + id + '/settings';
//     if (this.authService.getToken().length == 0) {
//       this.router.navigate(['/']);
//     }
//     const bearerToken = 'Bearer ' + this.authService.getToken();
//     return this.http.get<RekbotSettings>(endpoint, {
//       headers: new HttpHeaders().set('Authorization', bearerToken),
//     });
//   }